// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5da58eb1","239":"6d8f736f","455":"cf1894df","488":"fd18ca3f"}[chunkId] + ".chunk.js";
};